import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from '../../services/auth';
import { useAuth } from '../../context/AuthContext';
import { HiMenuAlt2, HiX, HiOutlineLogout } from 'react-icons/hi';

const Header = ({ sidebarOpen, setSidebarOpen }) => {
    const navigate = useNavigate();
    const { logout } = useAuth();
    const currentUser = getCurrentUser();

    const handleLogout = () => {
        logout();
        navigate('/login', { replace: true });
    };

    return (
        <header className="bg-white border-b relative z-50">
            <div className="flex items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
                <div className="flex items-center">
                    <button
                        onClick={() => setSidebarOpen(!sidebarOpen)}
                        className="lg:hidden text-gray-500 hover:text-gray-600 focus:outline-none focus:text-gray-600 relative z-50"
                        aria-label={sidebarOpen ? 'Close sidebar' : 'Open sidebar'}
                        aria-expanded={sidebarOpen}
                    >
                        {sidebarOpen ? <HiX className="h-6 w-6" /> : <HiMenuAlt2 className="h-6 w-6" />}
                    </button>
                </div>

                <div className="flex items-center space-x-6">
                    <span className="text-sm text-gray-600">
                        Welcome, {currentUser?.dealerName || currentUser?.username || 'Dealer'}
                    </span>
                    <button
                        onClick={handleLogout}
                        className="text-red-600 hover:text-red-800 focus:outline-none transition-colors duration-200"
                        aria-label="Logout"
                    >
                        <HiOutlineLogout className="h-6 w-6" />
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;